
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/college-storage-fee",
      function () {
        return require("private-next-pages/college-storage-fee/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/college-storage-fee"])
      });
    }
  